import { render, staticRenderFns } from "./Activate.vue?vue&type=template&id=2cb23ce1&scoped=true&"
import script from "./Activate.vue?vue&type=script&lang=js&"
export * from "./Activate.vue?vue&type=script&lang=js&"
import style0 from "./Activate.vue?vue&type=style&index=0&id=2cb23ce1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb23ce1",
  null
  
)

export default component.exports